interface ITotalResultsProps {
  quantity: number;
}

export const TotalResults: React.FC<ITotalResultsProps> = ({ quantity }) => {
  return quantity > 1 ? <>{quantity} results</> : <>{quantity} result</>;
};
